import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Callback from "./Callback";
import LandingPage from "./LandingPage";
import Playlists from "./Playlists";
import "./App.css";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/callback" element={<Callback />} />
        <Route path="/playlists" element={<Playlists />} />
      </Routes>
    </Router>
  );
}

export default App;
